type EventName =
  | 'lp_revenue_ai_view'
  | 'cta_calcular_click'
  | 'calc_completed'
  | 'cta_diagnostico_click'
  | 'form_submitted'
  | 'whatsapp_click'
  | 'scroll_depth'
  | 'product_scope_click';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

export function track(name: EventName, params: Record<string, unknown> = {}) {
  if (typeof window === 'undefined') return;

  if (typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  }

  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({ event: name, ...params });

  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.debug('[track]', name, params);
  }
}

export function initGA() {
  const id = import.meta.env.VITE_GA4_ID;
  if (!id || typeof window === 'undefined') return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer ?? [];
  function gtag(...args: unknown[]) {
    window.dataLayer?.push(args);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', id, { send_page_view: false });
}
